import React from 'react'
import './Heading.scss'

interface IHeading extends React.HTMLAttributes<HTMLHeadingElement> {
    size: 1 | 2 | 3
}

const Heading: React.FC<IHeading> = (props) => {
    const { children, className, size } = props
    const styles: Array<string | undefined> = ["heading", `h${size}`]
    styles.push(className)

    return (
        React.createElement(`h${size}`, { className: styles.filter(Boolean).join(" "), children: children })
    )
}

export default Heading